/* GGS hero fold — the split board (v5, 2026-09-02).

   Paired with sections/ggs-hero-fold.liquid and assets/ggs-hero-fold.css.
   The section renders every card layer and writes the card copy into
   data-cards as JSON; nothing here is templated, so this file is a plain
   static asset.

   THIS IS 7H34.FR'S MECHANISM, READ FROM THEIR SOURCE (global.min.js and
   global.min.css, 2026-09-02), not guessed from a recording:

     - Their dial has one hour mark per project and a progress arc that draws
       once round over the whole cycle (3.5 s per project). At each hour the
       live mark pops to full size and the change begins.
     - Their change: two solid colour panels, each a huge rectangle hinged at
       the CENTRE of the viewport, rotate 180 deg one after the other with
       linear rotation, the pair driven 0 to 1 over 1 s on their custom curve
       cubic-bezier(.85,0,.23,1). Visually that is a straight line through the
       centre going once round clockwise: the new colour arrives on its side
       during the first half-turn, the new picture on the other side during
       the second. It starts at twelve when the new panel is on the right and
       at six when it is on the left. Here the same thing is done with a conic
       mask on the incoming card, pivot at the dial's centre.
     - The panel SWAPS SIDES ON EVERY CHANGE, not by card index. With an odd
       number of cards, index parity puts the last card and the first on the
       same side, and if they share a colour the first half-turn changes
       nothing on screen: the digits roll, nothing happens, then only the
       photograph wipes (Aubrey's recording, 2026-09-02). The section marks
       even cards right for the first lap; after that the script decides.
     - Their digits roll 0.75 s on the same curve, columns 0.1 s apart. The
       old caption fades 0.5 s from the start; the sweep starts 0.25 s in;
       the new caption slides up 40px over 0.6 s (Expo out) 0.25 s before the
       sweep ends.

   QA HOOK. Append #ggsf=card2, #ggsf=card3 or #ggsf=wipe2@0.5 to the URL and
   the board freezes in that state (the @ value is the sweep's progress). A
   fragment survives Shopify's preview redirect; a query string does not.

   2026-09-22: PER-BEAT STATEMENT. When the section is given statements for
   beats 2 and 3, the reading-side h1 carries data-tt, a JSON array of three
   ready-rendered HTML strings (marks and lead already applied in Liquid).
   setCaptions swaps it at the same moment it swaps the fine line, i.e. while
   the reading side is faded out by is-out, so it fades exactly like the rest
   of the corner copy. Indexed by the card's ORIGINAL position (_i), because
   cards without a plate are filtered out below. No data-tt: nothing happens
   and the h1 stays static, which is what page.workspace relies on. */
(function () {
  var root = document.getElementById('ggs-hero-fold');
  if (!root) return;

  var S;
  try { S = JSON.parse(root.getAttribute('data-cards') || '[]'); }
  catch (e) { return; }
  S = S.map(function (c, i) { if (c) c._i = i; return c; })
       .filter(function (c) { return c && c.img; });
  if (!S.length) return;

  var LAP = parseInt(root.getAttribute('data-lap'), 10) || 3500;   /* one hour */
  var N = S.length;
  var CYCLE = N * LAP;
  /* the change, in ms from the hour: */
  var FADE_OUT = 500, SWEEP_AT = 250, SWEEP = 1000, LAND_AT = 1000, DONE = 1250;
  var reduce = !!(window.matchMedia &&
                  window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var q = function (sel) { return [].slice.call(root.querySelectorAll(sel)); };
  var layers = q('.ggsf__card');
  var read = document.getElementById('ggsf-read');
  var ring = root.querySelector('.ggsf__ring');
  var halfL = q('.ggsf__half--l'), halfR = q('.ggsf__half--r');
  var hours = q('.ggsf__hour');
  var figEls = q('[data-fig]'), kEls = q('[data-k]'), cEls = q('[data-c]'),
      sEls = q('[data-s]'), hEls = q('[data-h]'), mEls = q('[data-m]');
  if (!layers.length || !read) return;
  var ttEl = read.querySelector('[data-tt]'), TT = null;
  if (ttEl) { try { TT = JSON.parse(ttEl.getAttribute('data-tt')); } catch (e) { TT = null; } }
  if (layers.length < N) { S = S.slice(0, layers.length); N = S.length; CYCLE = N * LAP; }

  /* Warm the plates so the first change does not reveal a half-loaded picture. */
  S.forEach(function (c) {
    var im = new Image(); im.src = c.img;
    if (c.jar && root.getAttribute('data-showjar') === '1') { var j = new Image(); j.src = c.jar; }
  });

  /* cubic-bezier(.85,0,.23,1) — their "projects-transition" and "dial-digits". */
  function bezier(x1, y1, x2, y2) {
    function A(a1, a2) { return 1 - 3 * a2 + 3 * a1; }
    function B(a1, a2) { return 3 * a2 - 6 * a1; }
    function C(a1) { return 3 * a1; }
    function calc(t, a1, a2) { return ((A(a1, a2) * t + B(a1, a2)) * t + C(a1)) * t; }
    function slope(t, a1, a2) { return 3 * A(a1, a2) * t * t + 2 * B(a1, a2) * t + C(a1); }
    return function (x) {
      if (x <= 0) return 0; if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var s = slope(t, x1, x2); if (s === 0) break;
        t -= (calc(t, x1, x2) - x) / s;
      }
      return calc(t, y1, y2);
    };
  }
  var EASE = bezier(0.85, 0, 0.23, 1);

  /* sRGB relative luminance, so the light-panel inversion follows the actual
     colour rather than a hard-coded card index. */
  function lum(hex) {
    var m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec((hex || '').trim());
    if (!m) return 0;
    var c = [1, 2, 3].map(function (i) {
      var v = parseInt(m[i], 16) / 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  /* which side each card's panel is on right now; the section's classes set
     the first lap, beginChange flips the incoming card to the other side from
     the outgoing one from then on */
  var sides = S.map(function (c, i) { return i % 2 === 1; });
  /* 2026-09-30: ON A PHONE (<=767px) THE PANEL IS ALWAYS ON TOP. The stacked
     layout has no left and right, only the half-l copy (clipped to the top)
     and the half-r copy (clipped to the bottom), and the panel is now the top
     one, i.e. "left". So while the query matches, panelRight() answers false
     for every card and everything that reads it - the ink, ggsf--pr, the
     sweep's start angle - follows the panel to the top. The RAW alternation in
     sides[] keeps running underneath (beginChange flips from sides, not from
     panelRight), so crossing back to >=768px lands on a coherent
     alternating state. The query is live: see the change listener below. */
  var mqPhone = window.matchMedia ? window.matchMedia('(max-width:767px)') : null;
  function phone() { return !!(mqPhone && mqPhone.matches); }
  function panelRight(n) { return phone() ? false : sides[n]; }
  function placeCard(n, right) {
    sides[n] = !!right;
    layers[n].classList.toggle('ggsf__card--pr', sides[n]);
  }
  function isLight(n) { return lum(S[n].col) > 0.35; }

  /* The ink of each clock copy follows what is under that half right now. */
  function inkHalf(side, n) {
    var dark = (side === 'r') === panelRight(n) && isLight(n);
    (side === 'r' ? halfR : halfL).forEach(function (h) { h.classList.toggle('is-dark', dark); });
  }
  function setPanelState(n) {
    root.classList.toggle('ggsf--light', isLight(n));
    root.classList.toggle('ggsf--pr', panelRight(n));
  }
  function setHour(n) {
    hours.forEach(function (h, i) { h.classList.toggle('is-on', i === n); });
  }
  var ARC_LEN = 2 * Math.PI * 97;
  function setArc(frac) {
    root.style.setProperty('--arc', (ARC_LEN * (1 - frac)).toFixed(2));
  }

  /* ---- the sweep: a conic mask on the incoming card, pivot at the dial ---- */
  var centre = '50% 50%';
  function measureCentre() {
    if (!ring) return;
    var r = root.getBoundingClientRect(), g = ring.getBoundingClientRect();
    if (!r.width || !r.height) return;
    centre = (((g.left + g.width / 2) - r.left) / r.width * 100).toFixed(2) + '% ' +
             (((g.top + g.height / 2) - r.top) / r.height * 100).toFixed(2) + '%';
  }
  var s0 = 0;
  function applySweep(n, t) {
    var d = 360 * EASE(t);
    var m = 'conic-gradient(from ' + s0 + 'deg at ' + centre + ', #000 0deg, #000 ' +
            Math.max(0, d - 0.35).toFixed(2) + 'deg, rgba(0,0,0,0) ' +
            Math.min(360, d + 0.35).toFixed(2) + 'deg)';
    var L = layers[n];
    L.style.webkitMaskImage = m; L.style.maskImage = m;
    return d;
  }
  function clearSweep(n) {
    var L = layers[n];
    L.style.webkitMaskImage = ''; L.style.maskImage = '';
  }

  /* Odometer roll on a group of elements that show the same string. Both
     clock copies carry the same figure, so every element in a group rolls
     together. The figure carries a ≥ that Hanken lacks; it is wrapped so CSS
     can size the fallback glyph to the digits. Text is compared, markup is
     written. */
  function figHTML(str) { return String(str).replace('≥', '<i class="ggsf__ge">≥</i>'); }
  function roll(els, val) {
    els.forEach(function (el) {
      var old = el.textContent;
      if (old === val) return;
      if (reduce) { el.innerHTML = figHTML(val); return; }
      el.innerHTML = '<b class="ggsf__roll"><i>' + figHTML(old) + '</i><i>' + figHTML(val) + '</i></b>';
      var b = el.firstChild;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { b.classList.add('is-go'); });
      });
      setTimeout(function () { el.innerHTML = figHTML(val); }, 800);
    });
  }
  function setText(els, val) { els.forEach(function (el) { el.innerHTML = figHTML(val); }); }
  function setCaptions(c) {
    setText(kEls, c.k); setText(cEls, c.c); setText(sEls, c.s);
    if (TT && TT[c._i] != null) ttEl.innerHTML = TT[c._i];
  }
  function setAll(c) { setText(figEls, c.fig); setText(hEls, c.h); setText(mEls, c.m); setCaptions(c); }

  /* ---- the change, as a little timeline ---- */
  var cur = 0, nxt = 0, tr = null;   /* tr: {start, rolled, swept, inked1, inked2, landed} */

  function beginChange(n, ts) {
    nxt = n;
    if (n !== cur) placeCard(n, !sides[cur]);        /* always the other side (raw, not the phone's forced one) */
    /* desktop: start at twelve for a right-hand panel, six for a left one. Phone:
       the panel is the top half, so start at nine o'clock and the first half-turn
       (nine, twelve, three) lays the new colour down before the picture. */
    s0 = phone() ? 270 : (panelRight(n) ? 0 : 180);
    measureCentre();
    applySweep(n, 0);
    layers[n].classList.add('is-in');
    root.classList.add('is-out');            /* captions and corner fade */
    tr = { start: ts, rolled: false, inked1: false, inked2: false, landed: false, staged: false };
  }
  function tickChange(ts) {
    var e = ts - tr.start;
    if (!tr.rolled) {                        /* digits roll from the start, columns 0.1 s apart */
      tr.rolled = true;
      roll(figEls, S[nxt].fig);
      roll(hEls, S[nxt].h);
      setTimeout(function () { roll(mEls, S[nxt].m); }, 100);
    }
    var d = 0;
    if (e >= SWEEP_AT) d = applySweep(nxt, Math.min(1, (e - SWEEP_AT) / SWEEP));
    /* each half takes the new ink once the line has crossed its middle */
    var first = panelRight(nxt) ? 'r' : 'l', second = first === 'r' ? 'l' : 'r';
    if (!tr.inked1 && d >= 90)  { tr.inked1 = true; inkHalf(first, nxt); }
    if (!tr.inked2 && d >= 270) { tr.inked2 = true; inkHalf(second, nxt); }
    if (!tr.staged && e >= FADE_OUT) {       /* invisible now: move the corner to its new side */
      tr.staged = true;
      setPanelState(nxt); setCaptions(S[nxt]);
      root.classList.add('is-staged');
    }
    if (!tr.landed && e >= LAND_AT) {        /* slide the new corner copy up into place */
      tr.landed = true;
      root.classList.remove('is-out');
      root.classList.add('is-landing');
      root.offsetWidth;                      /* commit the staged frame before releasing it */
      root.classList.remove('is-staged');
    }
    if (e >= DONE) endChange();
  }
  function endChange() {
    if (!tr) return;
    if (!tr.staged) { setPanelState(nxt); setCaptions(S[nxt]); }
    inkHalf('l', nxt); inkHalf('r', nxt);
    layers[cur].classList.remove('is-on');
    var L = layers[nxt];
    L.classList.remove('is-in'); L.classList.add('is-on');
    clearSweep(nxt);
    root.classList.remove('is-out'); root.classList.remove('is-staged');
    setTimeout(function () { root.classList.remove('is-landing'); }, 650);
    cur = nxt; tr = null;
  }
  function instantTo(n) {
    if (tr) endChange();
    layers[cur].classList.remove('is-on');
    layers[n].classList.add('is-on');
    clearSweep(n);
    cur = n; setPanelState(n); setAll(S[n]); inkHalf('l', n); inkHalf('r', n); setHour(n);
  }

  setPanelState(0); inkHalf('l', 0); inkHalf('r', 0); setHour(0); setArc(0);

  /* Crossing 767px (rotating a tablet, resizing a window): finish any change in
     flight, then re-read which side the panel is on. */
  function onPhoneChange() {
    if (tr) endChange();
    setPanelState(cur); inkHalf('l', cur); inkHalf('r', cur);
    measureCentre();
  }
  if (mqPhone) {
    if (mqPhone.addEventListener) mqPhone.addEventListener('change', onPhoneChange);
    else if (mqPhone.addListener) mqPhone.addListener(onPhoneChange);
  }

  /* QA hook — see the note at the top of the file. */
  var frozen = false;
  var qa = /ggsf=(card|wipe)(\d)(?:@([\d.]+))?/.exec(location.hash + location.search);
  if (qa && N > 1) {
    var want = Math.min(N - 1, Math.max(0, (parseInt(qa[2], 10) || 1) - 1));
    frozen = true;
    if (qa[1] === 'card') {
      instantTo(want); setArc(want / N);
    } else {
      instantTo((want + N - 1) % N);          /* wipe1 is the wrap: last card into the first */
      var pq = Math.min(1, Math.max(0, parseFloat(qa[3]))); if (isNaN(pq)) pq = 0.5;
      beginChange(want, 0); setHour(want); setArc(want / N);
      tr.rolled = true;
      tickChange(SWEEP_AT + pq * SWEEP);     /* freeze exactly there */
      if (pq >= 0.75) { root.classList.remove('is-out'); root.classList.remove('is-staged'); root.classList.add('is-landing'); }
    }
  }

  /* ---- the clock ---- */
  var live = true, t0 = null, hour = 0, running = true;
  function step(ts) {
    if (frozen) return;
    if (!live) { running = false; return; }
    if (t0 === null) t0 = ts - hour * LAP;
    var el = (ts - t0) % CYCLE;
    var h = Math.floor(el / LAP);
    if (!reduce) setArc(el / CYCLE);
    if (h !== hour) {
      hour = h;
      if (!tr) {
        if (reduce) { instantTo(h); setArc(h / N); } else { setHour(h); beginChange(h, ts); }
      }
    }
    if (tr) tickChange(ts);
    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);

  /* Pause off-screen and in hidden tabs, or the board lands on a random card
     and burns paint nobody is looking at. Pausing mid-change finishes it at
     once rather than stranding a half-revealed layer; the hour restarts. */
  function setLive(v) {
    if (frozen || v === live) return;
    live = v;
    if (!v && tr) endChange();
    t0 = null;
    if (v && !running) { running = true; requestAnimationFrame(step); }
  }
  document.addEventListener('visibilitychange', function () { setLive(!document.hidden); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { setLive(e.isIntersecting && !document.hidden); });
    }, { threshold: 0.25 }).observe(root);
  }
})();
